import React from "react";
import { useRouter } from "expo-router";
import { useAtomValue, useSetAtom } from "jotai/react";

import { ApplicationScreenLayout } from "@/blocks/ApplicationScreenLayout";
import { DocumentsSection } from "@/blocks/DocumentsSection";
import { VnBox } from "@/components/VnBox";
import { VnCard } from "@/components/VnCard";
import { VnText } from "@/components/VnText/VnText";
import { useUpdateCurrentPatientMutation } from "@/data/mutations/patientsMutations";
import { useListHouseholdMembersQuery } from "@/data/queries/householdMembersQueries";
import {
  applicationCurrentStepAtom,
  applicationTotalStepsAtom,
} from "@/stores/atoms";
import { formatHouseholdMemberName } from "@/utils/householdMember";

export const ApplicationDocumentsScreen = () => {
  const router = useRouter();
  const setApplicationCurrentStep = useSetAtom(applicationCurrentStepAtom);
  const applicationTotalSteps = useAtomValue(applicationTotalStepsAtom);
  const { mutate: updateCurrentPatient } = useUpdateCurrentPatientMutation();

  const { data: householdMembers = [] } = useListHouseholdMembersQuery();

  const handleNext = () => {
    updateCurrentPatient(
      {
        patientData: {
          applicationLastStep: "DOCUMENTS",
        },
      },
      {
        onSuccess: () => {
          setApplicationCurrentStep(step =>
            Math.min(step + 1, applicationTotalSteps),
          );

          router.navigate({
            pathname: "/(authed)/(modal)/application/submit",
          });
        },
      },
    );
  };

  return (
    <ApplicationScreenLayout
      onNextButtonPress={handleNext}
      titleI18nKey="native:applicationDocuments.title"
      descriptionI18nKey="native:applicationDocuments.description">
      <VnBox className="gap-4">
        {householdMembers.map(member => (
          <VnCard key={member.id}>
            <VnText variant="lgMedium">
              {formatHouseholdMemberName(member)}
            </VnText>

            <DocumentsSection
              householdMemberId={member.id}
              householdMemberFullName={formatHouseholdMemberName(
                member,
                "fullName",
              )}
            />
          </VnCard>
        ))}
      </VnBox>
    </ApplicationScreenLayout>
  );
};
